import React, {useRef, useEffect} from 'react';
import {Box} from '@mui/material';
import {Swiper, SwiperSlide} from 'swiper/react';
import {EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const SwipeableContainer = ({
  slides,
  activeIndex,
  onSlideChange,
  isLargeScreen,
  config,
  swiperRef: externalRef,
  cardRef,
  onCategorySelect, // Add this prop
  categories, // Add this prop
}) => {
  const internalRef = useRef(null);
  const swiperRef = externalRef || internalRef;

  useEffect(() => {
    if (swiperRef.current?.swiper && activeIndex !== undefined) {
      swiperRef.current.swiper.slideTo(activeIndex);
    }
  }, [activeIndex]);

  const swiperProps = isLargeScreen
    ? {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        },
      }
    : {
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 300,
        allowTouchMove: true,
      };

  // Debug logging
  console.log('SwipeableContainer onCategorySelect:', typeof onCategorySelect);

  return (
    <Box sx={{position: 'relative', width: '100%', mb: 6}}>
      <Swiper
        ref={swiperRef}
        {...swiperProps}
        pagination={config?.swiperConfig?.isSwiperPagination ? {clickable: true} : false}
        navigation={config?.swiperConfig?.isSwiperNavigation ? true : false}
        modules={[EffectCoverflow, EffectFade, Navigation, Pagination]}
        onSlideChange={onSlideChange}
        onSwiper={swiper => onSlideChange(swiper)}
        className={isLargeScreen ? 'large-swiper' : 'mobile-swiper'}
      >
        {slides.map((slide, index) => {
          const SlideComponent = slide.component;

          // Create updated props with the handlers - THIS IS THE KEY FIX
          const slideProps = {
            ...slide.props,
            handleCategorySelect: onCategorySelect, // Pass the handler
            activeCategoryIndex: activeIndex, // Pass current active index
            cardRef: activeIndex === index ? cardRef : null, // Only pass cardRef to active slide
          };

          // Debug logging for each slide
          console.log(`Slide ${index} handleCategorySelect:`, typeof slideProps.handleCategorySelect);

          return (
            <SwiperSlide key={slide.key || index}>
              <div className={`slide-content ${index === activeIndex ? 'active' : ''}`}>
                <SlideComponent
                  {...slideProps} // USE slideProps instead of slide.props
                />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Box>
  );
};
